import React from 'react';
import Preloader from 'ati-ui-react/components/Preloader';
import styles from './styles.modules.scss';

const MobilePreloader = () => {
    return (
        <div className={styles['mobile-preloader']}>
            <Preloader />
        </div>
    );
};

export default MobilePreloader;
